import { TFunction } from "i18next";
import { CLOSING_DISCLOSURE, HUD_1, REFINANCE } from "utils/constants";

export type ChargeTab = { code: string, label: string, labelKey: string };

export const chargesTabs: Record<"purchase" | "refinance" | "hud1", ChargeTab[]> = {
  purchase: [
    { code: "A", label: "Origination Charges", labelKey: "tab-origination-charges" },
    { code: "B", label: "Did Not Shop For", labelKey: "tab-did-not-shop-for" },
    { code: "C", label: "Did Shop For", labelKey: "tab-did-shop-for" },
    { code: "E", label: "Taxes and Fees", labelKey: "tab-taxes-and-fees" },
    { code: "F", label: "Prepaids", labelKey: "tab-prepaids" },
    { code: "G", label: "Escrow", labelKey: "tab-escrow" },
    { code: "H", label: "Other Charges", labelKey: "tab-other-charges" },
    { code: "J", label: "Lender Credits", labelKey: "tab-lender-credits" },
    { code: "K-M", label: "Debits And Credits", labelKey: "tab-debits-and-credits" },
    { code: "L-N", label: "Debits And Credits", labelKey: "tab-debits-and-credits" },
  ],
  refinance: [
    { code: "A", label: "Origination Charges", labelKey: "tab-origination-charges" },
    { code: "B", label: "Did Not Shop For", labelKey: "tab-did-not-shop-for" },
    { code: "C", label: "Did Shop For", labelKey: "tab-did-shop-for" },
    { code: "E", label: "Taxes and Fees", labelKey: "tab-taxes-and-fees" },
    { code: "F", label: "Prepaids", labelKey: "tab-prepaids" },
    { code: "G", label: "Escrow", labelKey: "tab-escrow" },
    { code: "H", label: "Other Charges", labelKey: "tab-other-charges" },
    { code: "J", label: "Lender Credits", labelKey: "tab-lender-credits" },
    { code: "K", label: "Debits and Credits", labelKey: "tab-debits-and-credits" },
  ],
  hud1: [
    { code: "J-K", label: "Summary of Transactions", labelKey: "tab-summary-of-transactions" },
    { code: "700", label: "Commissions", labelKey: "tab-commissions" },
    { code: "800", label: "Loan Charges", labelKey: "tab-loan-charges" },
    { code: "900", label: "Prepaid Items", labelKey: "tab-prepaid-items" },
    { code: "1000", label: "Impounds", labelKey: "tab-impounds" },
    { code: "1100", label: "Title Charges", labelKey: "tab-title-charges" },
    { code: "1200", label: "Recording Charges", labelKey: "tab-recording-charges" },
    { code: "1300", label: "Additional Charges", labelKey: "tab-additional-charges" },
  ]
};

interface GetChargesTabsParams {
  orderType: string,
  transactionType: string
}

export const getChargesTabs = ({
  orderType,
  transactionType
}: GetChargesTabsParams) => {
  if (orderType === HUD_1) return chargesTabs.hud1;
  if (orderType === CLOSING_DISCLOSURE && transactionType === REFINANCE) return chargesTabs.refinance;

  return chargesTabs.purchase;
};

// Tab titles are translated through `charges:<labelKey>`; the English label is the fallback.
export const getChargeTabLabel = (t: TFunction, tab: Pick<ChargeTab, 'label' | 'labelKey'>) =>
  `${t(`charges:${tab.labelKey}`, { defaultValue: tab.label })}`;
